<button
  type="{{ type }}"
  class="add-icon cursor-pointer btn-{{ size }}"
  [class.active]="active"
  [class.disabled]="disabled"
  [class.light]="variant === 'light'"
  [class.transparent]="variant === 'transparent'"
  (click)="custom_click.emit($event)"
  href="#"
  aria-label="Add">
  <app-ce-icon
    [name]="IconType"
    [ngClass]="{ 'loader-spin': IconType === 'loader' }"
    [disabled]="disabled"
    aria-hidden="true"></app-ce-icon>
</button>
